import xlsx from 'xlsx'
import { CompsError } from '@compsError'

/**
 * Parse the xlsx workbook, get the raw workbook object
 * @param {ArrayBuffer} arrayBuffer - uint8array buffer
 * @returns {Promise<Object>} promise that resolves the XLSX object
 */
function parseXlsx(arrayBuffer) {
  return xlsx.read(arrayBuffer, { type: 'array' })
}

/**
 * Parse an Comps XLSX drawn down from Omniview
 * @param {ArrayBuffer} arrayBuffer - array buffer (retrieved from a FileReader.readAsArrayBuffer(File))
 * @returns {Promise<Array>} promise that resolves to an Array of objects for each property in the comps list
 */

function parseCompSheet(arrayBuffer) {
  const sheetData = []
  const workbook = parseXlsx(arrayBuffer)
  const sheet_name_list = workbook.SheetNames

  if (sheet_name_list && sheet_name_list.length > 0) {
    for (let i = 0; i < sheet_name_list.length; i += 1) {
      sheetData[sheet_name_list[i]] = xlsx.utils.sheet_to_json(workbook.Sheets[sheet_name_list[i]], { blankrows: false, defval: '' })
    }
  }

  if (!workbook.Sheets.Summary && !workbook.Sheets['Map Data']) {
    throw new CompsError('Incorrect file is uploaded, Summary and Map Data worksheets are missing')
  } else if (!workbook.Sheets.Summary) {
    throw new CompsError('Incorrect file is uploaded, Summary worksheet is missing')
  } else if (!workbook.Sheets['Map Data']) {
    throw new CompsError('Incorrect file is uploaded, Map Data worksheet is missing')
  }

  return sheetData
}

export {
  parseXlsx,
  parseCompSheet
}
